module.exports = __webpack_public_path__ + "media/application/images/world-map-2b5efeb5261cf1941c0e17ddf9f8007c.svg";